<template>
  <div class="fixed top-20 lg:top-25 w-full z-toast">
    <GContainer id="g-toasts-manager" class="!lg:px-6 space-y-4"/>
  </div>
</template>
